export const API_KEY = 'AIzaSyDi96T6Q0Ku2G2ui3VeBkEwecm0HjcNfy0'
